import styled from 'styled-components';
import { Input } from 'antd';
import { styleVariables } from '../../../style';
export var CommentPreviewSurface = styled.div.withConfig({
  displayName: "comment-preview-surfacecomponent__CommentPreviewSurface",
  componentId: "sc-qjj5vx-0"
})(["box-sizing:border-box;border:", " solid ", ";border-left-width:", ";border-left-color:", ";border-radius:", ";background:", ";box-shadow:0 4px 12px rgba(15,23,42,0.15);"], styleVariables.borderWidth.small, function (props) {
  return props.$borderMode === 'full' ? props.$commentColor : styleVariables.colors.gray9;
}, function (props) {
  return props.$borderMode === 'full' ? styleVariables.borderWidth.small : '5px';
}, function (props) {
  return props.$commentColor;
}, styleVariables.borderRadius.large, function (props) {
  return props.theme.color.backgroundPrimary;
});
export var CommentPreviewContent = styled.div.withConfig({
  displayName: "comment-preview-surfacecomponent__CommentPreviewContent",
  componentId: "sc-qjj5vx-1"
})(["margin:0;padding:", " ", ";border-radius:", ";background:", ";color:", ";font-size:", ";font-weight:", ";line-height:1.5;"], styleVariables.padding.small, styleVariables.padding.medium, styleVariables.borderRadius.small, styleVariables.colors.gray2, function (props) {
  return props.theme.color.textPrimary;
}, styleVariables.font.fontSizeSmall, styleVariables.font.fontWeightStrong);
export var CommentTextArea = styled(Input.TextArea).withConfig({
  displayName: "comment-preview-surfacecomponent__CommentTextArea",
  componentId: "sc-qjj5vx-2"
})(["min-height:100px !important;resize:none;border:", " solid ", " !important;border-radius:", " !important;padding:", " ", " !important;background:", " !important;box-shadow:none !important;&:hover,&:focus,&.ant-input-focused{border-color:", " !important;}&:focus,&.ant-input-focused{box-shadow:0 0 0 2px rgba(25,90,255,0.12) !important;}"], styleVariables.borderWidth.small, function (props) {
  return props.theme.color.borderDefault;
}, styleVariables.borderRadius.medium, styleVariables.padding.medium, styleVariables.padding.large, function (props) {
  return props.theme.color.backgroundPrimary;
}, function (props) {
  return props.theme.color.primary;
});